import Backend from 'shared/lib/Backend';
import sectionTools from 'fantastic/lib/sections';
import debouncedSaveTemplate from "fantastic/lib/debouncedSaveTemplate";

const dispatchStartSaving = dispatch => dispatch({ type: 'START_SAVING' });
const dispatchFinishSaving = dispatch => dispatch({ type: 'FINISH_SAVING' });
const dispatchErrorOnSaving = dispatch => dispatch({ type: 'ERROR_SAVING' });

export default async (dispatch, getState) => {

  const { sections, app: { savingInProgress }, settings: { lock_version }, theme: { style_attributes } } = getState();

  if ( savingInProgress ) {
     // console.log(`saving is ${savingInProgress} run deferred saving with debounce`);
     debouncedSaveTemplate(dispatch, getState);
    return;
  }

  dispatchStartSaving(dispatch);

  const clearedSections = JSON.parse(JSON.stringify(sections));
  sectionTools.prepareForSave(clearedSections);
  const body = JSON.stringify({ sections: clearedSections, lock_version });
  try {
    const response = await Backend.requestJson(`${window.location.pathname}/update`, { body }, "PUT");

    const snapshot = JSON.stringify({ sections: clearedSections, theme: style_attributes });
    dispatch({ type: 'VERSIONS/PUSH', payload: { newSnapshot: snapshot } });

    if(response.result === 'success'){
      dispatchFinishSaving(dispatch);
      dispatch({ type: 'SETTINGS/VERSION/UP', payload: response.lock_version });

    } else if ( response.result === 'conflict') {
      dispatchErrorOnSaving(dispatch);
      dispatch({ type: "FAIL/CONFLICT", payload: response.message });
    } else if ( response.result === 'refresh') {
      dispatchErrorOnSaving(dispatch);
      window.location.reload();
    } else if ( response.result === 'error') {
      dispatchErrorOnSaving(dispatch);
      const { message } = response;
      console.log( response );
      dispatch({ type: "FAIL/JSON", payload: typeof message === 'object' && !Array.isArray(message) && message !== null ? JSON.stringify(message) : message });
    } else {
      dispatchErrorOnSaving(dispatch);
    }
  }catch(e) {
    console.log(e);
    dispatchErrorOnSaving(dispatch);
  }
};

